import { api } from '../../api/client';
import { API_BASE_URL } from '../../config/api';
import { mapWebOrderTypeForApi } from '../Account/Payment/webOrderTypeUtils';
import { parseUnavailableLineItems } from './cartAvailabilityUtils';

/**
 * @param {Array<{ id: number, price: number, quantity: number }>} cartItems
 */
export function buildCheckCartOrderItems(cartItems) {
  return cartItems.map((item) => ({
    itemID: Number(item.id),
    price: Number(item.price),
    quantity: Number(item.quantity),
    customizations: [],
  }));
}

/**
 * @param {unknown} data
 */
export function parseCheckCartResponse(data) {
  const root = data && typeof data === 'object' ? /** @type {Record<string, unknown>} */ (data) : {};
  const detail =
    root.detail && typeof root.detail === 'object'
      ? /** @type {Record<string, unknown>} */ (root.detail)
      : null;

  const readNum = (key) => {
    const v = detail?.[key] ?? root[key];
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  };

  const unavailableItems = parseUnavailableLineItems(detail);
  const hasUnavailableLines = unavailableItems.length > 0;

  return {
    packagingCharges: readNum('packagingCharges'),
    deliveryCharges: readNum('deliveryCharges'),
    gstPercent: readNum('GST') ?? 5,
    unavailableItems,
    isAvailable: !hasUnavailableLines && root.isAvailable !== false,
    unavailableMessage:
      detail && typeof detail.message === 'string' ? detail.message : null,
  };
}

/**
 * @param {{
 *   token: string,
 *   cartItems: Array<{ id: number, price: number, quantity: number }>,
 *   distanceKm: number,
 *   fulfillmentType?: string,
 * }} params
 */
export async function fetchCheckCart({ token, cartItems, distanceKm, fulfillmentType = 'delivery' }) {
  const { data } = await api.post(
    `${API_BASE_URL}/orders/checkCart`,
    {
      orderItems: buildCheckCartOrderItems(cartItems),
      orderType: mapWebOrderTypeForApi(fulfillmentType),
      distance: Number(distanceKm) || 0,
    },
    {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
      timeoutMs: 25000,
    },
  );
  return parseCheckCartResponse(data);
}
